module.exports = __webpack_public_path__ + "img/customer.4c176486.jpg";